import { KEYBOARD_KEYS } from './constants';

export class KeyboardUtils {
  static isActionKey(key: string): boolean {
    return key === KEYBOARD_KEYS.ENTER || key === KEYBOARD_KEYS.SPACE;
  }

  static isEscapeKey(key: string): boolean {
    return key === KEYBOARD_KEYS.ESCAPE;
  }

  static setupEscapeHandler(callback: () => void): () => void {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (KeyboardUtils.isEscapeKey(event.key)) {
        callback();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }

  static toggleBodyScroll(disable: boolean): void {
    document.body.style.overflow = disable ? 'hidden' : 'unset';
  }
}